import { render, staticRenderFns } from "./DefaultCampaign.vue?vue&type=template&id=41de68bc"
import script from "./DefaultCampaign.vue?vue&type=script&lang=js"
export * from "./DefaultCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports